import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const ReviewPage: React.FC = () => {
  return (
    <>
      <Header />
      <div>리뷰 페이지</div>
      <Footer />
    </>
  );
};

export default ReviewPage;
